enum RouteEnum {
  Root = '/',
  creditScore = 'credit-score-old',
  creditScoreNew = 'credit-score',
  vehicleSearch = 'vehicle-search',
  tradeIn = 'trade-in',
  leadGen = 'lead-gen',
  GoogleReview = 'google-review',
  Showcase = 'show-case',
  DigitalRetailing = 'digital-retailing',
  CheckAvailability = 'check-availability',
  MultiCTA = 'multi-cta',
  ContactUs = 'contact-us',
  BookAppointment = 'book-appointment',
}

export default RouteEnum;
